import {useEffect, useState} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {useSearchParams} from 'react-router-dom';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useQueryParams} from '../../../../pages/private/hooks';

const ALL_SPECIALTIES_KEY = 'ALL';

const useSpecialtyFilter = () => {
	const specialtySearchParamKey = 'specialty';
	const queryClient = useQueryClient();
	const {
		setSearchParams,
		SEARCH_PARAMS: {query},
	} = useQueryParams();
	const [searchParams] = useSearchParams();
	const specialtySearchParam = searchParams.get(specialtySearchParamKey) || '';
	const [specialtySelected, setSpecialtySelected] = useState<string | null>(null);
	const [subSpecialtySelected, setSubSpecialtySelected] = useState<string | null>(null);

	const handleSpecialtyClick = (name: string, subName?: string) => {
		const isToggleOff = name === specialtySelected;
		setSearchParams(prev => {
			if (isToggleOff) {
				prev.delete(specialtySearchParamKey);
			} else {
				prev.set(specialtySearchParamKey, name);
			}
			return prev;
		});
		setSpecialtySelected(isToggleOff ? null : name);
		setSubSpecialtySelected(isToggleOff ? null : subName ?? null);
	};

	const handleResetSpecialty = () => {
		setSpecialtySelected(null);
		setSubSpecialtySelected(null);
		setSearchParams(prev => {
			prev.delete(specialtySearchParamKey);
			return prev;
		});
		queryClient.refetchQueries({
			queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_DOCTORS],
			stale: true,
		});
	};

	useEffect(() => {
		if (specialtySearchParam) {
			setSpecialtySelected(specialtySearchParam);
			setSearchParams(prev => {
				prev.set(specialtySearchParamKey, specialtySearchParam);
				return prev;
			});
		}
	}, [specialtySearchParam]);

	return {specialtySelected, subSpecialtySelected, handleSpecialtyClick, handleResetSpecialty, query};
};

export {useSpecialtyFilter, ALL_SPECIALTIES_KEY};
